module.exports = __webpack_public_path__ + "img/Hide.a5c624d9.svg";